/**
 * Cart Bar — Fixed floating bar at the bottom of the screen.
 * Shows item count + total price. Tapping opens the Order Sheet.
 */

import { getCurrentLanguage } from '../../../i18n';
import type { CartItem } from '../types';

const LABELS: Record<string, { view: string; items: string }> = {
  th: { view: 'ดูออเดอร์', items: 'รายการ' },
  en: { view: 'View Order', items: 'item(s)' },
  zh: { view: '查看订单', items: '项' },
  ru: { view: 'Посмотреть заказ', items: 'позиция' },
  ja: { view: '注文を見る', items: '品' },
  ko: { view: '주문 보기', items: '개' },
};

export function renderCartBar(cart: Map<string, CartItem>): string {
  const totalQty = [...cart.values()].reduce((s, c) => s + c.qty, 0);
  const subtotal = [...cart.values()].reduce((s, c) => s + c.item.price * c.qty, 0);

  if (totalQty === 0) return '<div id="cart-bar" style="display:none;"></div>';

  const lang = getCurrentLanguage();
  const lbl = LABELS[lang] || LABELS.en;

  return `
    <div id="cart-bar" style="
      position:fixed;bottom:0;left:0;right:0;
      padding:12px 16px calc(12px + env(safe-area-inset-bottom, 0px)) 16px;
      background:#00B900;color:#fff;
      display:flex;align-items:center;justify-content:space-between;
      z-index:200;box-shadow:0 -2px 12px rgba(0,180,0,0.25);
      cursor:pointer;touch-action:manipulation;
    " onclick="window.openOrderSheet?.()">
      <div style="
        display:flex;align-items:center;justify-content:center;
        background:rgba(255,255,255,0.25);border-radius:20px;
        padding:4px 10px;font-size:13px;font-weight:700;
      ">${totalQty} ${lbl.items}</div>
      <span style="font-size:15px;font-weight:700;">${lbl.view}</span>
      <span style="font-size:15px;font-weight:700;">฿${subtotal.toLocaleString()}</span>
    </div>
  `;
}

/** Re-render just the cart bar in-place without full page refresh */
export function refreshCartBar(cart: Map<string, CartItem>): void {
  const existing = document.getElementById('cart-bar');
  if (!existing) return;
  const wrapper = document.createElement('div');
  wrapper.innerHTML = renderCartBar(cart);
  const newEl = wrapper.firstElementChild as HTMLElement;
  if (newEl) existing.replaceWith(newEl);
}
